import { ShopwareProduct } from '@services/types/Shopware';

export function ucfirst(str: string): string {
    if (!str) return str; // Return empty string if input is empty
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function newportRounding(n: number): number {
    return n > Math.floor(n) + 0.6 ? Math.ceil(n) : Math.floor(n);
}

export function dateFormat(date: Date): string {
    if (!(date instanceof Date) || isNaN(date?.getTime())) {
        console.warn('Unknown date input', date);
        return '(unknown date)';
    }

    return date.toISOString().split('T')[0];
}

export function getSeoUrl(product: ShopwareProduct) {
    if (!product?.seoUrls?.[0]) {
        return `/detail/${product.id}`;
    }

    return `/${product.seoUrls[0].seoPathInfo}`;
}
